import { useDispatch, useSelector } from 'react-redux'

import { EnergyContract } from '../model/energyContract.model'
import { fetchEnergyContract } from '../store/energyContract.reducer'
import {
  selectEnergyContract,
  selectEnergyContractLoading,
  selectEnergyContractError,
} from '../store/energyContract.selectors'

import { selectAgent } from '~/auth/store/auth.selectors'
import { useBrand } from '~/brand'
import { StoreError } from '~/common/model'

interface useEnergyContract {
  fetchEnergyContracts: (documentId: string) => unknown
  energyContracts?: EnergyContract[]
  loading: boolean
  error?: StoreError
}

export default function useEnergyContract(): useEnergyContract {
  const dispatch = useDispatch()
  const { brand } = useBrand()
  const { agent } = useSelector(selectAgent)

  return {
    fetchEnergyContracts: (documentId: string) =>
      dispatch(
        fetchEnergyContract({
          brand,
          documentId,
          sub: agent?.sub,
        }),
      ),
    energyContracts: useSelector(selectEnergyContract),
    loading: useSelector(selectEnergyContractLoading),
    error: useSelector(selectEnergyContractError),
  }
}
